import { Star, GoogleLogo, ArrowRight } from "@phosphor-icons/react";
import { Chapter, Reveal } from "@/components/site/Reveal";

const REVIEWS = [
    {
        name: "Dennis",
        area: "Treasure Valley, ID",
        text: "Way beyond my expectations! The turf came out amazing. Eric and his team did it exactly how I told them and it came out looking flawless!",
    },
    {
        name: "Bryan",
        area: "Treasure Valley, ID",
        text: "Eric and his team did a great job. They finished the job exactly how I wanted it. I definitely would recommend them!!",
    },
];

export const Reviews = () => {
    return (
        <section
            id="reviews"
            data-testid="reviews-section"
            className="relative border-t border-brand-border/60 bg-white py-24 md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <Chapter
                    index="05"
                    label="Reviews"
                    testid="reviews-chapter"
                    title={
                        <>
                            What Treasure Valley{" "}
                            <span className="italic text-brand-accent">homeowners say</span>.
                        </>
                    }
                    copy="Real installs, real neighbors. Ask us for references — we're happy to connect you with past customers in your city."
                />

                <div className="grid gap-5 md:grid-cols-3">
                    {REVIEWS.map((r, i) => (
                        <Reveal key={i} delay={i * 0.07}>
                            <figure
                                data-testid={`review-card-${i}`}
                                className="spotlight flex h-full flex-col rounded-3xl border border-brand-border bg-white p-7 transition-colors duration-500 hover:border-brand-accent/40"
                            >
                                <div className="flex items-center gap-1 text-brand-accent">
                                    {Array.from({ length: 5 }).map((_, s) => (
                                        <Star key={s} size={16} weight="fill" />
                                    ))}
                                </div>
                                <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-brand-text md:text-base">
                                    "{r.text}"
                                </blockquote>
                                <figcaption className="mt-6 border-t border-brand-border pt-4">
                                    <p className="font-display text-base font-semibold text-brand-text">{r.name}</p>
                                    <p className="mt-0.5 text-xs font-semibold uppercase tracking-[0.14em] text-brand-muted">
                                        {r.area}
                                    </p>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}

                    <Reveal delay={0.15}>
                        <a
                            href="https://www.google.com/search?q=treasure+valley+turf+%26+greens"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="review-cta-card"
                            className="group flex h-full flex-col items-start justify-between rounded-3xl border border-brand-accent/40 bg-brand-accent/5 p-7 transition-colors duration-500 hover:bg-brand-accent/10"
                        >
                            <div>
                                <GoogleLogo size={28} weight="bold" className="text-brand-accent" />
                                <p className="font-display mt-5 text-2xl font-medium leading-snug text-brand-text">
                                    Had a great experience?{" "}
                                    <span className="italic text-brand-accent">Leave us a review</span>.
                                </p>
                                <p className="mt-3 text-sm leading-relaxed text-brand-muted">
                                    Google reviews are the biggest way neighbors find us — it takes two minutes and means the world to our crew.
                                </p>
                            </div>
                            <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-brand-accent">
                                Review us on Google
                                <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
                            </span>
                        </a>
                    </Reveal>
                </div>

                <Reveal delay={0.2}>
                    <p className="mt-8 flex items-center gap-2 text-sm text-brand-muted">
                        <GoogleLogo size={18} weight="bold" className="text-brand-accent" />
                        Find our latest reviews on our Google Business Profile.
                    </p>
                </Reveal>
            </div>
        </section>
    );
};
